const toPositiveId = (value) => {
  const parsed = Number(value);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
};

const toPositiveQuantity = (value) => {
  const parsed = Number(String(value ?? "").replace(",", "."));
  return Number.isFinite(parsed) && parsed > 0
    ? Number(parsed.toFixed(5))
    : null;
};

const findProduct = (products, productId) =>
  (Array.isArray(products) ? products : []).find(
    (product) => Number(product?.id) === Number(productId)
  );

const buildAdjustmentDraftItems = (rawItems = [], products = []) => {
  const byProductId = new Map();

  (Array.isArray(rawItems) ? rawItems : []).forEach((rawItem) => {
    const productId = toPositiveId(
      rawItem?.product_id ?? rawItem?.produit_id ?? rawItem?.id
    );
    const quantity = toPositiveQuantity(
      rawItem?.missing_quantity ?? rawItem?.quantity
    );
    if (!productId || !quantity) return;

    const adjustmentType =
      rawItem?.adjustment_type === "subtract" ? "subtract" : "add";
    const existing = byProductId.get(productId);
    if (existing && existing.adjustment_type === adjustmentType) {
      existing.quantity = Number((existing.quantity + quantity).toFixed(5));
      return;
    }
    if (existing) return;

    const product = findProduct(products, productId);
    byProductId.set(productId, {
      key: String(productId),
      product_id: productId,
      product_name:
        rawItem?.product_name ||
        product?.name ||
        product?.nom_produit ||
        `Produit ${productId}`,
      current_stock: Number(product?.current_stock ?? rawItem?.available_quantity) || 0,
      adjustment_type: adjustmentType,
      quantity,
    });
  });

  return Array.from(byProductId.values());
};

const buildAdjustmentBatchPayload = (draftItems = []) =>
  (Array.isArray(draftItems) ? draftItems : []).map((item) => ({
    product_id: toPositiveId(item?.product_id),
    quantity: toPositiveQuantity(item?.quantity),
    adjustment_type:
      item?.adjustment_type === "subtract" ? "subtract" : "add",
  }));

module.exports = {
  buildAdjustmentBatchPayload,
  buildAdjustmentDraftItems,
  toPositiveQuantity,
};

